import React from "react";

import { Dropdown as DSDropdown } from "@packages/ds";

import type { DropdownCommandMenuProps } from "@packages/ds";

const CommandMenu = ({
  triggerLabel,
  headerContent,
  tabs = [],
  disabled = false
}: DropdownCommandMenuProps) => {
  return (
    <DSDropdown.CommandMenu
      triggerLabel={triggerLabel}
      headerContent={headerContent}
      tabs={tabs}
      disabled={disabled}
    />
  );
};

export default CommandMenu;
